import React from 'react'

const Privacy = () => {
  return (
    <div>
      <div>
            <div className="site-wrap" id="home-section">
                <div
                    style={{
                        backgroundImage:
                            "url(https://pricelessrentalsusa.com/wp-content/uploads/2023/07/mt-1582-home-header-bg-1.jpg)"
                    }}
                >
                
            
                    <div className="ftco-blocks-cover-1">
                        <div className="ftco-cover-1 overlay innerpage">
                            <div className="container">
                                <div className="row align-items-center justify-content-center">
                                    <div className="col-lg-6 text-center">
                                        <h1>Our Policy</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="site-section" style={{ backgroundColor: "#dfdaf3" }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-8 offset-md-2">
                                <h2>Eligibility for Rental:</h2>
                                <p style={{ fontSize: "large" }}>
                                    Renters must be at least 21 years old (or the legal age as per local
                                    laws). A valid driving license is required at the time of rental.
                                    Renters must provide a valid government-issued ID and a credit/debit
                                    card for verification and payment.
                                </p>
                                <h2 className="mt-5">Vehicle Condition:</h2>
                                <p style={{ fontSize: "large" }}>
                                    All vehicles are rented out in good working condition. Renters are
                                    responsible for returning the car in the same condition as it was at
                                    the time of rental, barring normal wear and tear.
                                </p>
                                <h2 className="mt-5">Fuel Policy:</h2>
                                <p style={{ fontSize: "large" }}>
                                    Fuel is not included in the rental. The car will be rented out
                                    without fuel, and the renter is responsible for refueling as needed
                                    during the rental period. The car must be returned with at least the
                                    same level of fuel as at the time of pick-up to avoid additional
                                    charges for refueling services.
                                </p>
                                <h2 className="mt-5">Rental Period:</h2>
                                <p style={{ fontSize: "large" }}>
                                    The rental period starts when the car is picked up and ends when it
                                    is returned. Late returns may incur additional charges.
                                </p>
                                <h2 className="mt-5">Insurance Coverage:</h2>
                                <p style={{ fontSize: "large" }}>
                                    Our cars are covered by comprehensive insurance. This insurance
                                    provides coverage for accidents, theft, and other potential
                                    incidents, subject to the terms of the insurance policy. Any damages
                                    not covered by the comprehensive insurance will be charged to the
                                    renter.
                                </p>
                                <h2 className="mt-5">Maintenance and Repairs:</h2>
                                <p style={{ fontSize: "large" }}>
                                    Renters must inform the company of any mechanical issues or
                                    accidents during the rental period. Unauthorized repairs are not
                                    allowed and will not be reimbursed.
                                </p>
                                <h2 className="mt-5">Prohibited Uses:</h2>
                                <p style={{ fontSize: "large" }}>
                                    The vehicle must not be used for illegal activities, racing, towing,
                                    or driving on unapproved terrains.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
  )
}

export default Privacy
